'use client';

import React, { useEffect } from 'react';
import { useTabsContext } from '../../context/TabsProvider';
import { twMerge } from 'tailwind-merge';
interface TabSetProps {
  children: React.ReactNode;
  id?: string;
  defaultIndex?: number;
  direction?: 'horizontal' | 'vertical';
  className?: string;
  variant?: 'default' | 'primary';
}

const TabSet = ({
  children,
  id: providedId,
  defaultIndex = 0,
  direction = 'horizontal',
  className = '',
  variant = 'default',
}: TabSetProps) => {
  const generatedId = Math.random().toString(36).substring(2, 15);
  const id = providedId || generatedId;
  const { dispatch } = useTabsContext();

  useEffect(() => {
    dispatch({
      type: 'REGISTER_TABSET',
      payload: {
        id,
        defaultIndex,
        direction,
      },
    });
    return () => dispatch({ type: 'UNREGISTER_TABSET', payload: { id } });
  }, [id, defaultIndex, direction, dispatch]);

  const variantStyles = {
    default: 'border-b border-neutral-100',
    primary: 'border-b-2 border-transparent',
  };

  const baseClassName =
    direction === 'vertical' ? 'flex flex-col' : 'flex flex-row';

  return (
    <div
      data-tabset-id={id}
      className={twMerge(
        `${baseClassName} ${variantStyles[variant]} ${className}`
      )}
    >
      {children}
    </div>
  );
};

export default TabSet;
